module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmhead"
  }, [_vm._v("Abbreviations")]), _vm._v(" "), _c('table', {
    staticClass: "tab"
  }, [_c('tbody', [_c('tr', [_c('td', [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("AGOS")])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Aviation, Hydro-aviation and Prototype Aircraft Production")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("DRP")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Dynamo-Reactive (Recoilless) Gun")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("GUAP")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Principal Directorate of the Aviation Industry")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("GVF")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Civil Air Fleet")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("KhAZOS")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Kharkov Aviation Plant of Prototype Manufacturing")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NII GVF")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Scientific Research Institute of Civil Air Fleet")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NII VVS")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Air Force Scientific Testing Institute")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NKAP")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("People’s Commissariat for the Aviation Industry")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NKTP")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("People’s Commissariat for Heavy Industry")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("OGPU")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("United Principal Political Directorate")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("OKDVA")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Special Red-Banner Far East Army")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("OKPB")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Special Design and Manufacturing Bureau")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("OTB")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Special Technical Bureau")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("RKKA")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Worker’s and Peasant’s Red Army;")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("RVS")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Revolutionary Military Council;")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("STO")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Council for Labour and Defence;")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("TsAGI")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Central Aero- and Hydrodynamics Institute.")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("UVVS")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Air Force Directorate;")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("VAMM")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Military Academy of Mechanisation and Motorisation")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("VOIZ")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("All Union Society of Inventors")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("VVS")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Air Force")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aef33552","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Abbreviations.vue
// module id = 69
// module chunks = 0